import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsBlockWrapper',
  setup(__props) {

const tabContentHeight = ref<number>(0);
const openTabId = ref<number>(0);
const openTab = (idx: number) => {
  openTabId.value = idx;
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    openTabId: openTabId.value,
    openTab: openTab,
    tabContentHeight: tabContentHeight.value
  })
}
}

})